import React, { useState } from 'react';
import ScannerCard from './ScannerCard';
import ScannerConfigModal from './ScannerConfigModal';
import './ScannerList.css';

function ScannerList({ scanners, onScannerUpdated, onTestWebhook }) {
    const [selectedScanner, setSelectedScanner] = useState(null);
    const [viewMode, setViewMode] = useState('cards'); // 'cards' or 'table'

    const handleConfigClick = (scanner) => {
        setSelectedScanner(scanner);
    };

    const handleCloseModal = () => {
        setSelectedScanner(null);
    };

    const handleConfigUpdated = () => {
        setSelectedScanner(null);
        onScannerUpdated();
    };

    if (scanners.length === 0) {
        return (
            <div className="empty-state">
                <p>No scanners found. Create your first scanner to get started.</p>
            </div>
        );
    }

    return (
        <>
            <div className="view-toggle">
                <button
                    className={`view-toggle-btn ${viewMode === 'cards' ? 'active' : ''}`}
                    onClick={() => setViewMode('cards')}
                    title="Card View"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="3" width="7" height="7" />
                        <rect x="14" y="3" width="7" height="7" />
                        <rect x="3" y="14" width="7" height="7" />
                        <rect x="14" y="14" width="7" height="7" />
                    </svg>
                </button>
                <button
                    className={`view-toggle-btn ${viewMode === 'table' ? 'active' : ''}`}
                    onClick={() => setViewMode('table')}
                    title="Table View"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="3" y1="6" x2="21" y2="6" />
                        <line x1="3" y1="12" x2="21" y2="12" />
                        <line x1="3" y1="18" x2="21" y2="18" />
                    </svg>
                </button>
            </div>

            {viewMode === 'cards' ? (
                <div className="scanner-list">
                    {scanners.map((scanner) => (
                        <ScannerCard
                            key={scanner.id}
                            scanner={scanner}
                            onConfigClick={handleConfigClick}
                            onTestWebhook={onTestWebhook}
                        />
                    ))}
                </div>
            ) : (
                <div className="scanner-table-wrapper">
                    <table className="scanner-table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Status</th>
                                <th>Scanner Serial</th>
                                <th>Base Unit Serial</th>
                                <th>HVerify Serial</th>
                                <th>Webhook</th>
                                <th>Security Policy</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {scanners.map((scanner) => {
                                const hasWebhook = scanner.config?.functionalityType === 'WEBHOOK' &&
                                                 (scanner.config?.webhook || scanner.config?.webhookUrl);
                                return (
                                    <tr key={scanner.id}>
                                        <td className="scanner-name-cell">
                                            <strong>{scanner.name}</strong>
                                        </td>
                                        <td>
                                            <span className={`status-badge ${scanner.isConnected ? 'status-connected' : 'status-disconnected'}`}>
                                                {scanner.isConnected ? 'Connected' : 'Disconnected'}
                                            </span>
                                        </td>
                                        <td className="serial-cell">{scanner.scannerSerial}</td>
                                        <td className="serial-cell">{scanner.baseUnitSerial}</td>
                                        <td className="serial-cell">{scanner.hverifySerial}</td>
                                        <td>{scanner.webhookName || '-'}</td>
                                        <td>{scanner.securityPolicyName || '-'}</td>
                                        <td className="actions-cell">
                                            <button
                                                onClick={() => handleConfigClick(scanner)}
                                                className="btn-small btn-primary"
                                            >
                                                Configure
                                            </button>
                                            {hasWebhook && (
                                                <>
                                                    <button
                                                        onClick={() => onTestWebhook(scanner.id, 'ok')}
                                                        className="btn-small btn-success"
                                                        title="Test OK Webhook"
                                                    >
                                                        Test OK
                                                    </button>
                                                    <button
                                                        onClick={() => onTestWebhook(scanner.id, 'nok')}
                                                        className="btn-small btn-danger"
                                                        title="Test NOK Webhook"
                                                    >
                                                        Test NOK
                                                    </button>
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}

            {selectedScanner && (
                <ScannerConfigModal
                    scanner={selectedScanner}
                    onClose={handleCloseModal}
                    onUpdated={handleConfigUpdated}
                />
            )}
        </>
    );
}

export default ScannerList;
